import Link from 'next/link'
import Head from 'next/head'

export {
    Link,
    Head
}
